var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconImagequality = function SvgIconImagequality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 6.448H4c-.552 0-1 .434-1 .97v7.48l3.894-4.119a1.53 1.53 0 0 1 2.212 0l4.048 4.282a.51.51 0 0 0 .726.011l2.464-2.45a1.533 1.533 0 0 1 2.121-.025L21 14.995V7.418c0-.536-.448-.97-1-.97M2 16.145v.97c0 1.071.895 1.94 2 1.94h16c1.105 0 2-.869 2-1.94V7.418c0-1.071-.895-1.94-2-1.94H4c-1.105 0-2 .869-2 1.94zm19 .97v-.765l-3.233-3.06a.51.51 0 0 0-.707.01l-2.464 2.45a1.53 1.53 0 0 1-2.18-.033L8.37 11.434a.51.51 0 0 0-.738 0L3 16.334v.78c0 .536.448.97 1 .97h16c.552 0 1-.434 1-.97m-7.402-5.818c.552 0 1-.434 1-.97s-.448-.97-1-.97c-.553 0-1 .434-1 .97s.447.97 1 .97",
    clipRule: "evenodd"
  })));
};
export default SvgIconImagequality;